import { render } from "./GlTableTwoColumnsRow.vue?vue&type=template&id=cf938a8a&scoped=true"
import script from "./GlTableTwoColumnsRow.vue?vue&type=script&lang=js"
export * from "./GlTableTwoColumnsRow.vue?vue&type=script&lang=js"

import "./GlTableTwoColumnsRow.vue?vue&type=style&index=0&id=cf938a8a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-cf938a8a"

export default script